<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="row">
    <app-person-search-filter class="col-md-3  pr-0" [redirectSource]="redirectSource" [similarobject]="similarobject" [aiSuggestion]="aiSuggestion" [similarContinent]="similarobject?.data?.locationcontinent" (filterEvent)="onFilterEvent($event)"></app-person-search-filter>
  <div class="col-md-9 pl-1" *ngIf="!resetAll">
        <div
            class="row mb-1"
            *ngIf="redirectSource != 'talent-insights' &&
                    (isCalledFromSimilar === true || isSimilarCanidate == true || isComingFromJD || isComingNLSearch) "
        >
            <div class="col">
                <div class="wccard p-3 headerbg">
                    <div class="d-flex">
                        <div class="d-flex">
                            <!-- <span *ngIf="similarobject?.calledfrom == 'similar' || isSimilarCanidate" class="text-9696 f-14">
                                Similar Candidates
                            </span>
                            <span *ngIf="isComingFromJD">
                                Job Description
                            </span>
                               <span *ngIf="isComingNLSearch">
                                NL Search
                            </span> -->


                            <span *ngIf="(similarobject?.calledfrom == 'similar' || isSimilarCanidate) && (similarobject?.data?.fullname || similarCanidateFullName)" class="text-9696 f-14">
                                Based on
                                <span class="font-weight-500" style="color: #484b59;">{{similarobject?.data?.fullname ||
                                    similarCanidateFullName | titlecase}}'s</span>
                                Profile
                                </span>
                            <span *ngIf="isComingFromJD" class="text-9696">
                                Based on
                                <span class="font-weight-500" style="color: #484b59;">Job Description</span>
                            </span>
                                 <span *ngIf="isComingNLSearch" class="text-9696">
                                <span class="font-weight-500 pointer" matTooltip="{{nlSearchQuery}}"  [matTooltipClass]="{ 'big-tooltip text-black text-capitalize': true }" matTooltipPosition="above">"{{truncateText(nlSearchQuery) | titlecase}}"</span>
                                 </span>
                        </div>
                        <div class="ml-auto">
                            <button data-testid="auto-app-person-search-listing-button-1" class="sim-can-edit-btn" (click)="editSimilarCandidateFilters()"><i class="far fa-edit mr-1"></i>Edit</button>
                        </div>

                    </div>
                    <div *ngIf="modalFilters.length" class="d-flex" style="margin-top: 9px;">
                        <div class="w-100" id="modal-viewMore">
                            <div class="d-flex f-12 flex-wrap">
                                <span class="f-14 mb-4" *ngFor="let elem of modalFilters | slice:0:10;">
                                    <span class="similar-candidate-chip mx-1 px-2 py-1 text-capitalize f-14" *ngIf="elem != null"
                                        matTooltip="{{elem?.tooltipText}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                                        {{elem?.field}} <i *ngIf="elem?.isMandatory" class="mx-1 fa-thumbtack fas text-webbtree-green pointer"></i></span>
                                </span>
                                <span class="f-12 pointer text-webbtree-green mx-2" *ngIf="modalFilters.length > 5"
                                    (click)="viewmoredetails('viewMore','modal-ms')">
                                    View More
                                </span>

                            </div>
                        </div>
                        <div class="w-100" id="modal-viewLess" style="display: none;">
                            <div class="d-flex f-12 flex-wrap">
                                <span class="f-14 mb-4" *ngFor="let elem of modalFilters;">
                                    <span class="similar-candidate-chip mx-1 px-2 py-1 mb-1 text-capitalize f-14" *ngIf="elem != null"
                                        matTooltip="{{elem?.tooltipText}}"
                                        [matTooltipClass]="{ 'red-tooltip text-black': true }">{{elem?.field}} <i *ngIf="elem?.isMandatory" class="mx-2 fa-thumbtack fas text-webbtree-green pointer"></i></span>
                                </span>
                                <span class="pointer text-webbtree-green mx-1" *ngIf="modalFilters.length > 5"
                                    (click)="viewmoredetails('viewLess','modal-ms')">
                                    View Less
                                </span>
                            </div>
                        </div>

                    </div>


                </div>
            </div>
            </div>
        <div class="wccard d-flex flex-column mb-1 px-4 py-2 redirect-report" *ngIf="redirectSource == 'talent-insights' || redirectSource == 'company-insights'">
            <span class="mb-3">
                <span class="text-9696">{{redirectSource == 'talent-insights' ? ' Talent Insights' : redirectSource == 'company-insights' ? 'Company Insights' : '' }}</span>
                <i class="fal fa-angle-right text-9696 mx-1"></i>
                <span class="f-14 font-weight-600">Person search</span>
            </span>
            <span class="d-flex align-items-baseline flex-wrap" *ngIf="redirectJobTitleFilters?.length"><span class="text-9696 mr-3" style="width: 110px; text-align: right;">Job Title: </span>
                <span *ngFor="let filter of redirectJobTitleFilters; let index = index" class="d-flex mb-2 align-items-center">
                    <span class="redirect-filter-others">{{cleanCompanyName(filter) | titlecase}}</span>
                    <i *ngIf="index != redirectJobTitleFilters.length - 1" class="fas fa-circle text-d9d9d9 mx-1 text-9696" style="font-size:5px" aria-hidden="true"></i>
                </span>
            </span>
            <span class="d-flex align-items-baseline flex-wrap" *ngIf="redirectPastJobTitleFilters?.length"><span class="text-9696 mr-3" style="width: 110px; text-align: right;">Past Job Title: </span>
                <span *ngFor="let filter of redirectPastJobTitleFilters; let index = index" class="d-flex mb-2 align-items-center">
                    <span class="redirect-filter-others">{{cleanCompanyName(filter) | titlecase}}</span>
                    <i *ngIf="index != redirectPastJobTitleFilters.length - 1" class="fas fa-circle text-d9d9d9 mx-1 text-9696" style="font-size:5px" aria-hidden="true"></i>
                </span>
            </span>
            <span class="d-flex align-items-baseline flex-wrap" *ngIf="redirectSkillsFilters?.length"><span class="text-9696 mr-3" style="width: 110px; text-align: right;">Skills: </span>
                <span *ngFor="let filter of redirectSkillsFilters; let index = index" class="d-flex mb-2 align-items-center">
                    <span class="redirect-filter-others">{{cleanCompanyName(filter?.chipkey) | titlecase}}</span><i class="fas fa-thumbtack pointer ml-1 text-webbtree-green f-12" *ngIf="filter?.isMandatory" aria-hidden="true"></i>
                    <i *ngIf="index != redirectSkillsFilters.length - 1" class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:4px" aria-hidden="true"></i>
                </span>
            </span>
            <span class="d-flex align-items-baseline flex-wrap" *ngIf="(redirectSource == 'talent-insights' && (redirectLocationFilters?.length && getTalentInsightContinent())) || redirectLocationFilters?.length"><span class="text-9696 mr-3" style="width: 110px; text-align: right;">Location: </span>
                <span *ngFor="let filter of redirectLocationFilters; let index = index" class="d-flex mb-2 align-items-center">
                    <span class="redirect-filter-others">{{cleanCompanyName(filter) | titlecase}}</span>
                    <i *ngIf="index != redirectLocationFilters.length - 1" class="fas fa-circle text-d9d9d9 mx-1 text-9696" style="font-size:5px" aria-hidden="true"></i>
                </span>
            </span>
            <!-- For Talent Insights -->
            <span id="TIViewLess" class="d-flex align-items-baseline flex-wrap" *ngIf="redirectFilters?.length > 0 && (redirectSource === 'talent-insights' || redirectSource === 'company-insights')"><span class="text-9696 mr-3" style="width: 110px; text-align: right;">Filters: </span>
                <span *ngFor="let filter of redirectFilters | slice:0:5;" class="d-flex mb-2">
                    <span class="dstooltip f-12">
                        <span class="filters-tooltip-content">
                            <div class="hiderule">
                                <div>
                                    <span class="font-weight-normal f-12 hl-mssg">
                                        {{filter?.metaData?.tooltipText || filter.name}}
                                    </span>
                                </div>
                            </div>
                        </span>
                        <span class="redirect-filter mr-2">{{cleanCompanyName(filter.value) | titlecase}}</span>
                    </span>
                </span>
                <span class="f-12 pointer text-webbtree-green mx-1" *ngIf="redirectFilters?.length && redirectFilters?.length > 5"
                    (click)="viewmoredetails('viewMore','talent-insights-filters')">
                    View More
                </span>
            </span>

            <span id="TIViewMore" style="display: none !important;" class="d-flex align-items-baseline flex-wrap" *ngIf="redirectFilters?.length && (redirectSource === 'talent-insights' || redirectSource === 'company-insights')"><span class="text-9696 mr-3" style="width: 110px; text-align: right;">Filters: </span>
                <span *ngFor="let filter of redirectFilters" class="d-flex mb-2">
                    <span class="dstooltip f-12">
                        <span class="filters-tooltip-content">
                            <div class="hiderule">
                                <div>
                                    <span class="font-weight-normal f-12 hl-mssg">
                                        {{filter.name}}
                                    </span>
                                </div>
                            </div>
                        </span>
                        <span class="redirect-filter mr-2">{{cleanCompanyName(filter.value) | titlecase}}</span>
                    </span>
                </span>


                <span class="f-12 pointer text-webbtree-green mx-1" (click)="viewMoreSimilarCandidate"
                    (click)="viewmoredetails('viewLess','talent-insights-filters')">
                    View Less
                </span>
            </span>

          <span id="TIExcludeViewLess" class="d-flex align-items-baseline flex-wrap" *ngIf="excludeFilters?.length > 0 && (redirectSource === 'talent-insights' || redirectSource === 'company-insights')"><span class="text-9696 mr-3" style="width: 110px; text-align: right;">Excluded Filters: </span>
                <span *ngFor="let filter of excludeFilters | slice:0:5;" class="d-flex mb-2">
                    <span class="dstooltip f-12">
                        <span class="filters-tooltip-content">
                            <div class="hiderule">
                                <div>
                                    <span class="font-weight-normal f-12 hl-mssg">
                                        {{filter?.type}}
                                    </span>
                                </div>
                            </div>
                        </span>
                        <span class="redirect-filter mr-2">{{cleanCompanyName(filter.chipkey) | titlecase}}</span>
                    </span>
                </span>
                <span class="f-12 pointer text-webbtree-green mx-1" *ngIf="excludeFilters?.length && excludeFilters?.length > 5"
                    (click)="viewmoredetails('viewMore','talent-insights-filters-exclude')">
                    View More
                </span>
            </span>

            <span id="TIExcludeViewMore" style="display: none !important;" class="d-flex align-items-baseline flex-wrap" *ngIf="excludeFilters?.length && (redirectSource === 'talent-insights' || redirectSource === 'company-insights')"><span class="text-9696 mr-3" style="width: 65px; text-align: right;">Excluded Filters: </span>
                <span *ngFor="let filter of excludeFilters" class="d-flex mb-2">
                    <span class="dstooltip f-12">
                        <span class="filters-tooltip-content">
                            <div class="hiderule">
                                <div>
                                    <span class="font-weight-normal f-12 hl-mssg">
                                        {{filter?.type}}
                                    </span>
                                </div>
                            </div>
                        </span>
                        <span class="redirect-filter mr-2">{{cleanCompanyName(filter?.chipkey) | titlecase}}</span>
                    </span>
                </span>


                <span class="f-12 pointer text-webbtree-green mx-1"
                    (click)="viewmoredetails('viewLess','talent-insights-filters-exclude')">
                    View Less
                </span>
            </span>
            <!-- JD filters when redirected from talent-insights -->
            <span id="TIJDViewLess" class="d-flex align-items-baseline flex-wrap"
                *ngIf="modalFilters?.length > 0 && (redirectSource === 'talent-insights' || redirectSource === 'company-insights')"><span
                    class="text-9696 mr-3" style="text-align: right;">Job Description: </span>
                <span *ngFor="let filter of modalFilters | slice:0:5;" class="d-flex mb-2">
                    <span class="dstooltip f-12">
                        <span class="filters-tooltip-content">
                            <div class="hiderule">
                                <div>
                                    <span class="font-weight-normal f-12 hl-mssg">
                                        {{filter.tooltipText}}
                                    </span>
                                </div>
                            </div>
                        </span>
                        <span class="redirect-filter mr-2">{{cleanCompanyName(filter.field) | titlecase}}
                                <i *ngIf="filter?.isMandatory" class="mx-1 fa-thumbtack fas text-webbtree-green pointer"></i> </span>
                    </span>
                </span>
                <span class="f-12 pointer text-webbtree-green mx-1" *ngIf="modalFilters?.length && modalFilters?.length > 5"
                    (click)="viewmoredetails('viewMore','talent-insights-jd-filters')">
                    View More
                </span>
            </span>
            <!-- JD filters When redirectd from talent-insights -->
            <span id="TIJDViewMore" style="display: none !important;" class="d-flex align-items-baseline flex-wrap"
                *ngIf="modalFilters?.length > 0 && (redirectSource === 'talent-insights' || redirectSource === 'company-insights')"><span
                    class="text-9696 mr-3" style="text-align: right;">Job Description: </span>
                <span *ngFor="let filter of modalFilters;" class="d-flex mb-2">
                    <span class="dstooltip f-12">
                        <span class="filters-tooltip-content">
                            <div class="hiderule">
                                <div>
                                    <span class="font-weight-normal f-12 hl-mssg">
                                        {{filter.tooltipText}}
                                    </span>
                                </div>
                            </div>
                        </span>
                        <span class="redirect-filter mr-2">{{cleanCompanyName(filter.field) | titlecase}}
                            <i *ngIf="filter.isMandatory" class="mx-1 fa-thumbtack fas text-webbtree-green pointer"></i> </span>
                    </span>
                </span>
                <span class="f-12 pointer text-webbtree-green mx-1" *ngIf="modalFilters?.length && modalFilters?.length > 5"
                    (click)="viewmoredetails('viewLess','talent-insights-jd-filters')">
                    View Less
                </span>
            </span>

            <!-- For company insights for now -->
            <!-- <span class="d-flex align-items-baseline flex-wrap" *ngIf="redirectFilters?.length && redirectSource !== 'talent-insights'"><span class="text-9696 mr-3" style="width: 65px; text-align: right;">Filters: </span>
                <span *ngFor="let filter of redirectFilters" class="d-flex mb-2">
                    <span class="redirect-filter mr-2">{{cleanCompanyName(filter) | titlecase}}</span>
                </span>
            </span> -->
        </div>
        <div class="wccard wccard d-flex flex-column mb-1 px-4 py-2" *ngIf="isInsightsActive">
            <app-person-search-ai *ngIf="isInsightsActive" [totalcount]="totalCandidatesCount" [keyword]="searchKeyword" [insightsaidata]="insightsaidata"  [events]="insightsSubject.asObservable()" [isSimilarCandidatesFlow]="isSimilarCanidate" [isJDFlow]="isComingFromJD"></app-person-search-ai>

        </div>
        <!-- <div class="wccard d-flex flex-column " [ngClass]="{ 'mb-1 py-2': showOpenAISuggestions || isOpenAILoading }">
            <div *ngIf="!editQuery" class="col-12 d-flex align-items-start flex-column">
                <div *ngIf="showOpenAISuggestions && !isOpenAILoading" class="flex-shrink-0 d-flex h-100 align-items-center mb-1">
                  <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500">
                      <i class="fa fa-stars" style="color: #b500ff;"></i>
                      AI Search Suggestions
                    </span>
                    <i class="fal fa-info-circle ml-1 pointer" matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results." [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above"></i>
                </div>
                <div *ngIf="isOpenAILoading" class="shimmer-loader" style="height: 23px; width: 300px; border-radius: 10px;"></div>
                <div class="overflow-hidden">
                  <openai-suggested-titles [exclude]="excludeFromAI" [reactiveQuery]="true" [continent]="selectedContinent" [showCount]="false" (loading)="openaiLoading($event)" (change)="aiChipUpdate($event)" [updateChips]="updateChips" [query]="aiQuery" [removeSelected]="false" [selectedTitles]="selectedTitles" [onlyExisiting]="true"></openai-suggested-titles>
                </div>
              </div>
        </div> -->


        <div class="wccard d-flex justify-content-between mb-1 px-2 py-2 talentCountFixonScroll">
            <div class="d-flex align-items-center four-matrix" style="background-color: #f2f2f2; cursor: default; width: 100%;">
                <div *ngIf="!totalCandidatesCountAvailable" class="text-center">
                  <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="talent count">
                </div>
                <div *ngIf="totalCandidatesCountAvailable">
                    <span class="f-26 font-weight-600">{{formatNumberToIndianFormat(totalCandidatesCount)}}</span>
                    <p class="text-9696 f-12 mb-0">Talent Count</p>
                </div>
            </div>

            <!-- <div class="d-flex align-items-center four-matrix" [ngStyle]="{'background-color': isLikelyToMoveInFilterSelected ? '#f2f2f2' : ''}"  (click)="likelyToMoveIn && onClickMatrix('likelytomovein')">
                <div *ngIf="!likelyToMoveInCountAvailable" class="text-center">
                    <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="Likely to Move">
                </div>
                <div *ngIf="likelyToMoveInCountAvailable">
                    <div class="f-26 font-weight-600">{{formatNumberToIndianFormat(likelyToMoveIn)}}</div>
                    <p class="f-12 mb-0">Likely to Move <i class="fas fa-info-circle" matTooltip='Candidates identified as "Likely to Move" based on their average years of experience and current tenure at a company.' [matTooltipClass]="{ 'big-tooltip text-black': true }"></i></p>
                </div>

            </div> -->

            <div class="d-flex align-items-center four-matrix" style="background-color: #f2f2f2; cursor: default; width: 100%;">
                <div *ngIf="!medianTenureInCountAvailable" class="text-center">
                  <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="median tenure">
                </div>
                <div *ngIf="medianTenureInCountAvailable">
                    <!-- <span class="f-26 font-weight-600">{{getFormattedTenureForMatrix(totalMedianTanureCount)}}</span> -->
                    <span class="f-26 font-weight-600" [innerHTML]="getFormattedTenureForMatrix(totalMedianTanureCount)"></span>
                    <p class="f-12 mb-0">Median Tenure <i class="fas fa-info-circle" matTooltip='Median Tenure of the talent' [matTooltipClass]="{ 'big-tooltip text-black': true }"></i></p>
                </div>
            </div>

            <div class="d-flex align-items-center align-items-center diversity-matrix" style="width: 100%;">
                <div *ngIf="!genderDataAvailable" class="text-center" style="margin-top: 6px;">
                    <img src="../../assets/rolling-loader.gif" style="width: 16%;" alt="">
                </div>
                <div class="d-flex" style="width: 100%; height:100%" *ngIf="genderDataAvailable">
                    <div class="gender-ratio pl-1" [ngStyle]="{'background-color': isMaleMatrixSelected ? '#f2f2f2' : ''}" (click)="malePercent && onClickMatrix('Male')">
                            <div class="gender">
                                <i class="fas fa-male text-9696 f-20"></i>
                                <span class="f-26 font-weight-600 pl-2 pr-1" >{{malePercent}}</span>
                                <span class="f-18 font-weight-500">%</span>
                            </div>
                            <p class="f-12 text-center mb-0">Men</p>
                    </div>
                    <div class="male-box mt-1 text-9696 pt-2"> | </div>
                    <div class ="gender-ratio pr-1" [ngStyle]="{'background-color': isFemaleMatrixSelected ? '#f2f2f2' : ''}" (click)="femalePercent && onClickMatrix('Female')">
                        <div class="gender">
                            <i class="fas fa-female text-9696 f-20"></i>
                            <span class="f-26 font-weight-600 female-box pl-2 pr-1" >{{femalePercent}}</span>
                            <span class="f-18 font-weight-500">%</span>
                        </div>
                        <p class="f-12 text-center mb-0">Women</p>
                    </div>
                </div>
                <!-- <span class="text-9696 f-12">Gender Diversity</span> -->
            </div>
            <!-- commented changed jobs -->
            <!-- <div class="d-flex flex-column changedJobs">
                <div *ngIf="!changedJobsCountAvailable" class="text-center">
                    <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="changedJobs">
                </div>
                <div *ngIf="changedJobsCountAvailable">
                    <div class="f-26 font-weight-600 changedJobs-matrix" style="border: none;" [ngStyle]="{'background-color': isChangedJobsSelected ? '#f2f2f2' : ''}" (click)="changedJobs && onClickMatrix('changedJobs')">{{formatNumberToIndianFormat(changedJobs)}}</div>
                    <hr class="m-0">
                    <select data-testid="auto-app-person-search-listing-select-1" class="selectInMatrix" name="" id="" [(ngModel)]="changedJobDuration" (change)="changedJobAgg($event)">
                        <option value=3>Changed Jobs (Past 3 mnths)</option>
                        <option value=6>Changed Jobs (Past 6 mnths)</option>
                        <option value=9>Changed Jobs (Past 9 mnths)</option>
                        <option value=12>Changed Jobs (Past 1 year)</option>
                    </select>
                </div>
          </div> -->

          <div class="d-flex align-items-center four-matrix" [ngStyle]="{'background-color': isChangedJobsSelected ? '#f2f2f2' : ''}" (click)="changedJobs && onClickMatrix('changedJobs')">
            <div *ngIf="!changedJobsCountAvailable" class="text-center">
                <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="changedJobs">
            </div>
            <div *ngIf="changedJobsCountAvailable">
                <span class="f-26 font-weight-600">{{formatNumberToIndianFormat(changedJobs)}}</span>
                <p class=" f-12 mb-0" >Changed Jobs(past 1yr)</p>
            </div>
      </div>

        </div>

        <div class="wccard mb-1 d-flex justify-content-between align-items-center f-12 px-2 py-1" *ngIf="(redirectSource == 'company-insights' || redirectSource == 'talent-insights') && hasEuAccess != 1">
            <span>The counts may vary due to GDPR constraints. Profiles from the regions of "Europe," "Antarctica," and "Philippines" are not displayed.</span>
        </div>
        <div class="wccard mb-1 d-flex justify-content-between align-items-center" id="pagination-scroll" >
          <div class="d-flex align-items-center">
                <label class="wc-checkbox mb-0 ml-3" [ngStyle]="!isListingActive && {'display':'none'}"  *ngIf=" totalCandidatesCount">
                    <input data-testid="auto-app-person-search-listing-input-1" [(ngModel)]="selected" (change)="selectAll($event)" type="checkbox" id="mycheck" name="mycheck">
                    <i class="fas fa-check"></i>
                </label>
                <span class="py-3 pointer pr-8 text-9696 pl-3" (click)="onTabChange('listing')"
                    [ngClass]="{'isActive font-weight-600': isListingActive}">
                    <i class="far fa-users mr-2" [ngClass]="{'font-weight-600': isListingActive}"></i>
                    Profiles
                </span>
                <span class="py-3 pointer px-8 text-9696" (click)="onTabChange('insight')"
                    [ngClass]="{'isActive font-weight-600': isInsightsActive}">
                    <i class="fas fa-chart-line mr-2" [ngClass]="{'font-weight-600': isInsightsActive}"></i>
                    Insights
                </span>


          </div>
          <div *ngIf="isListingActive" class="d-flex justify-content-center align-items-center">
            <div class="mr-3" *ngIf="totalCandidatesCount">
              <span class="font-weight-600"> {{start==0? 1 : start+1}} - {{end}}</span> of   <span class="font-weight-600">{{formatNumberToIndianFormat(totalCandidatesCount)}}</span>
              </div>
              <p class="add-to-talentpool text-webbtree-green pointer my-2 mr-2 text-nowrap" *ngIf="candidatetoBeGrabbed.length > 1" (click)="sendEmailAndGrabCandidate(data)">
                  <i class="fas fa-user-plus mr-1"></i>
                  Add to Talent pool
              </p>
              <!-- commented because of bugs -->
              <!-- <span class="ml-2 mr-1 my-2 ats-cta-btn position-relative pointer" (click)="openAddToEmailCampaign({})" title="Add to Email Campaign" *ngIf="candidatetoBeGrabbed?.length > 0">
                  <i class="fa-solid fa-envelopes-bulk nr-2"></i>
              </span> -->
              <span class="ml-2 mr-1 my-2 ats-cta-btn position-relative pointer" (click)="openAddToScreenAiModal({})" title="Add to Screen Ai" *ngIf="candidatetoBeGrabbed?.length > 0">
                  <i class="fa-solid fa-globe nr-2"></i>
              </span>
                <span class="ml-2 mr-1 my-2 ats-cta-btn position-relative pointer" (click)="addToAegis({})"
                  title="Add to Aegis" *ngIf="candidatetoBeGrabbed?.length > 0 && isAegisConnected">
                  <!-- <i class="fa-solid fa-globe nr-2"></i> -->
                  <img src="../../assets/search/aegis.png" alt="Aegis">
                </span>

          </div>

        </div>

<!-- mini-scroll -->
          <div class="" *ngIf="totalCandidatesCount && isListingActive && !showLoaderbeforeDataLoad" id="candidate-list">
              <div class="sticktotop">
                  <div *ngFor="let data of candidateList; let i = index">
                      <app-candidate-quick-view [data]="data" [i]="i" [highlightkeywords]="highlightkeywords" (childEvents)="eventHandler($event)" [similarobjectdata]="similarobject" (refreshCurrentView)="refreshCurrentView($event)" [parsedJDKeys]="parsedjdkeys">
                          <div talentPoolBulkGrab>
                              <label class="wc-checkbox mr-3 mt-3" *ngIf="platformselected == 'LinkedIn'">
                                  <input data-testid="auto-app-person-search-listing-input-2" [checked]="data.selected" [(ngModel)]="data.selected"
                                      (change)="selectCandidate($event, data)" type="checkbox" id="mycheck" name="mycheck">
                                  <i class="fas fa-check"></i>
                              </label>
                          </div>

                          <div *ngIf="candidatetoBeGrabbed.length <=1" addToTalentPool class="d-flex">
                              <p class="add-to-talentpool text-webbtree-green pointer text-nowrap" (click)="extractCandidate(data)" style="border-radius: 0.25rem 0 0 0.25rem;">
                                  <i class="fas fa-user-plus mr-1"></i>
                                  Add to Talent pool
                              </p>
                            <!-- bs dropdown -->
                            <div class="dropdown">
                              <button data-testid="auto-app-person-search-listing-button-2" class="add-to-talentpool border-left-0 px-2 text-webbtree-green" style="border-radius: 0 0.25rem 0.25rem 0;outline: none;" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="f-11 fa-chevron-down fa-solid"></i>
                              </button>
                              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                <ng-container *ngIf="availableIntegrations.length">
                                  <a data-testid="auto-app-person-search-listing-a-1" class="dropdown-item px-3 text-webbtree-green f-12 text-truncate" *ngFor="let integration of availableIntegrations" (click)="addCandidateToIntegration(integration, data)" [title]="integration.name | titlecase">
                                    <span class="mr-2">
                                      <img [src]="integration.logo ? integration.logo : 'https://api.unified.to/docs/images/successfactors.png'" class="img-fluid" style="height: 15px;" alt="">
                                    </span>
                                    Add to {{ integration.name | titlecase }}
                                  </a>
                                </ng-container>
                                <ng-container *ngIf="!availableIntegrations.length">
                                  <a data-testid="auto-app-person-search-listing-a-2" class="dropdown-item px-3 text-webbtree-green f-12" [routerLink]="['/settings/ats-integrations']">
                                    <i class="fa-solid fa-puzzle mr-2"></i>Add to ATS
                                  </a>
                                </ng-container>
                                <ng-container *ngIf="isAegisConnected">
                                  <a data-testid="auto-app-person-search-listing-a-3" class="dropdown-item px-3 text-webbtree-green f-12" (click)="addToAegis(data)">
                                    <img style="height: 25px; width: 25px;" src="../../assets/search/aegis.png" alt="A">Add to Aegis
                                  </a>
                                </ng-container>
                              </div>
                            </div>
                          </div>

                          <!-- location display cards -->
                          <div  class="wccard mb-1 ai-container-box" *ngIf="i==2 && showLocationDisplayCard" locationDisplayCards>
                            <div class="ai-suggestions-header d-flex align-items-center">
                                <span class="font-weight-300 gtext mx-3 d-flex align-items-center">
                                    <i class="far fa-lightbulb-on mr-1"></i>
                                    AI Suggestion
                                </span>
                                <i class="fa-solid fa-close ml-auto f-16 mr-2 pointer mt-1" (click)="closeCard('location')"></i>
                            </div>

                            <div class="p-3 d-flex flex-column">
                                <span class="font-weight-600 mb-1">Hidden Gems: Disappointed in your results?</span>
                                <span class="text-9696 mb-3">Disappointed in your results? Try looking in some of the locations below since all of them have better volumes of talent with the skills you’re looking for.</span>
                                <div class="d-flex align-items-center flex-wrap">
                                    <span class="font-weight-500 mr-3">Add: </span>
                                    <span *ngFor="let loc of topSuggestedLocations; last as isLast" class="d-flex align-items-center">
                                        <span class="suggestion-chips mr-2 pointer" (click)="updateSuggestions(loc)" [ngClass]="{ 'isSelected': loc.isSelected }">
                                            <i class="far fa-plus mr-1"></i>
                                            <span class="text-truncate font-weight-500" [matTooltip]="loc.displayName | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">{{loc.displayName | titlecase}}</span>
                                        </span>
                                        <span *ngIf="isLast" class="suggestion-chips mr-2 pointer" (click)="!disableSuggestedLocationApplyButton && applySuggestion('location')" [ngClass]="disableSuggestedLocationApplyButton ? 'disable-btn':  'enable-btn'">Apply</span>
                                    </span>
                                </div>
                            </div>
                          </div>

                          <!-- company display cards -->
                          <div  class="wccard mb-1 ai-container-box" *ngIf="i==4 && showCompanyDisplayCard && !isMaleMatrixSelected && !isFemaleMatrixSelected && totalCandidatesCount>=1000" companyDisplayCards>
                            <div class="ai-suggestions-header d-flex align-items-center">
                                <span class="font-weight-300 gtext mx-3 d-flex align-items-center">
                                    <i class="far fa-lightbulb-on mr-1"></i>
                                    AI Suggestion
                                </span>
                                <i class="fa-solid fa-close ml-auto f-16 mr-2 pointer mt-1" (click)="closeCard('company')"></i>
                            </div>

                            <div class="p-3 d-flex flex-column">
                                <span class="font-weight-600 mb-1">Diversity Enhancement: Psst! We couldn’t help noticing . . . only <span style="color: #c845ab;">{{malePercent < 25 ? malePercent : femalePercent}}%</span> of your results are {{malePercent < 25 ? 'men' : 'women'}}.</span>
                                <span class="text-9696 mb-3">If you want to improve on that, try these companies because all of them have strong {{malePercent < 25 ? 'Men' : 'Women'}} diversity.</span>
                                <div class="d-flex align-items-center flex-wrap">
                                    <span class="font-weight-500 mr-3">Add: </span>
                                    <span *ngFor="let company of topSuggestedCompanies; last as isLast" class="d-flex align-items-center">
                                        <span class="suggestion-chips mr-2 pointer" (click)="updateSuggestions(company)" [ngClass]="{ 'isSelected': company.isSelected }">
                                            <i class="far fa-plus mr-1"></i>
                                            <span class="compnaylogoplaceholder" [ngStyle]="!company?.companylogo && {'min-width': '24px'}" style="height: 22px; width: 22px;">
                                                <img [src]="company?.companylogo" *ngIf="company?.companylogo" class="img-fluid" alt="">
                                                <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
                                            </span>
                                            <span class="text-truncate font-weight-500" [matTooltip]="company.displayName | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">{{company.displayName | titlecase}}</span>
                                        </span>
                                        <span *ngIf="isLast" class="suggestion-chips mr-2 pointer" (click)="!disableSuggestedCompanyApplyButton && applySuggestion('company')" [ngClass]="disableSuggestedCompanyApplyButton ? 'disable-btn':  'enable-btn'">Apply</span>
                                    </span>
                                </div>
                            </div>
                          </div>

                      </app-candidate-quick-view>
                  </div>
              </div>
          </div>

          <div class="py-4 justify-content-center wccard d-flex flex-column align-items-center" style="height: calc(100vh - 110px);" *ngIf="!totalCandidatesCount && isListingActive && !showLoaderbeforeDataLoad && !euAccessMessage && !euAccessTIMessage">
              <img src="../../assets/emptystate.png" class="empty-state-img"/>
              <!-- <p class="f-18 font-weight-600 mt-6">Results Not Found!</p> -->
              <p class="f-16 font-weight-600 mt-6">We couldn’t find matching profiles.</p>
            <div>
              <div class="mt-2">
                <p>To improve your results:</p>
                <ul>
                  <li>Start with essential job titles or skills.</li>
                  <li>Remove restrictive filters.</li>
                  <li>Try alternative keywords</li>
                  </ul>
              </div>

            </div>

          </div>
          <div class="py-4 justify-content-center wccard d-flex flex-column align-items-center" style="height: calc(100vh - 110px);" *ngIf="euAccessMessage && isListingActive && !showLoaderbeforeDataLoad">
            <img src="../../assets/emptystate.png" class="empty-state-img"/>

            <p class="f-16 font-weight-600 mt-6">{{euAccessMessage}}</p>

        </div>
        <div class="py-4 justify-content-center wccard d-flex flex-column align-items-center" style="height: calc(100vh - 110px);" *ngIf="euAccessTIMessage && isListingActive && !showLoaderbeforeDataLoad">
          <div class="sticktotop">
          <img src="../../assets/emptystate.png" class="empty-state-img"/>

          <p class="f-16 font-weight-600 mt-6">{{euAccessTIMessage}}</p>

      </div>
      </div>
          <div class="h-50 justify-content-center wccard d-flex flex-column align-items-center" *ngIf="showLoaderbeforeDataLoad">
              <div class="loader text-center" *ngIf="showLoaderbeforeDataLoad">
                <img *ngIf="showLoaderbeforeDataLoad" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
              </div>
          </div>

          <div *ngIf="isInsightsActive">
              <app-person-search-insights [searchHistoryRegion] = "searchHistoryRegion" (insightsEvents)="insightsEventHandler($event)" [similarContinent]="similarobject?.data?.locationcontinent"></app-person-search-insights>
          </div>

          <div class="new-card d-flex justify-content-center wccard align-items-center" [ngClass]="{'sticky-pagination': isScrolled}" *ngIf="!isInsightsActive && candidateList?.length > 0">
              <ngb-pagination [collectionSize]="totalCandidatesCount <= 500 ? totalCandidatesCount: 500" [maxSize]="5" [pageSize]="profilesPerPage" [rotate]="true"
                  (pageChange)="setPage($event)" [(page)]="currentPage">
                  <ng-template ngbPaginationPrevious> <span>

                      </span></ng-template>
                  <ng-template ngbPaginationNext> <span *ngIf="candidateList?.length && isListingActive && totalCandidatesCount > profilesPerPage">Next</span> </ng-template>
              </ngb-pagination>

              <div class="page-selection">
                Showing
                <select data-testid="auto-app-person-search-listing-select-2" class="wc-select" name="" id="" [(ngModel)]="profilesPerPage" (change)="updatePagePreference()">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                </select>
                Profiles per page
              </div>
          </div>
    </div>
     <div class="col-md-9 pl-1" *ngIf="resetAll">

          <div class="py-4 justify-content-center wccard d-flex flex-column align-items-center" style="height: calc(100vh - 110px);" >
              <img src="../../assets/emptystate.png" class="empty-state-img" />
              <p class="f-16 font-weight-600 mt-6">You haven’t started a search yet.</p>
              <p class="f-16 font-weight-600">Use the search filters to start finding candidates.</p>

          </div>
        </div>
</div>
<!-- </div> -->

<ngb-alert class="ngb-alert" *ngIf="success_message" type="success" (close)="success_message = ''">
    <span class="successCheck"><i class="fal fa-check"></i> </span>
    <span class="successmsg">{{ success_message }}</span>
</ngb-alert>

<ng-template #extractToTalentpool class="modal">
    <div class="modal-content">
      <div class="modal-header b pb-0">
        <h5 class="modal-title f-14 font-weight-500 mb-1">Add Candidate to Talentpool</h5>
        <button data-testid="auto-app-person-search-listing-button-3" type="button" class="close py-3 font-weight-normal" data-dismiss="modal" aria-label="Close"
          (click)="modalService.dismissAll()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <ng-container *ngIf="showTalentPoolInput">
        <p class="text-9696 px-3 mb-0">If you wish to add this profile to a particular talent pool, kindly specify the talent pool below</p>
        <div class="modal-body">

          <app-add-to-talentpool style="display: block; margin: 0px -24px;" calledFrom="searchToolBox" [profileurlsarray]="profileurlsarray" (passEntry)="talentPoolandCandidateDataEvent($event)" [uiChange]="true"></app-add-to-talentpool>

          <div class="button-add-talent float-right">
            <!-- <button data-testid="auto-app-person-search-listing-button-4" class="outlined-button" (click)="modalService.dismissAll()" style="background-color: white;">Skip</button> -->
            <!-- <button data-testid="auto-app-person-search-listing-button-5" (click)="saveDataToTalentpool()" [disabled]="disablebutton" [ngClass] = "disablebutton ? 'disabled-button' : 'enabled-button'">Save</button> -->

            <button data-testid="auto-app-person-search-listing-button-6" [disabled]="disablebutton" (click)="saveDataToTalentpool()" [ngClass] = "disablebutton ? 'disabled-button' : 'enabled-button'">
              <span [ngClass]="{ 'spinner-border text-light': addToTalentpoolSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addToTalentpoolSpinner }">
                {{addToTalentpoolSpinner ? '' : 'Save'}}
              </span>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!showTalentPoolInput">
        <div class="modal-body">
            <p>{{talentPoolMessage}}</p>
            <div class="float-right d-flex flex-row justify-content-end">
              <button data-testid="auto-app-person-search-listing-button-7" class="outlined-button" *ngIf="addTalentPoolSuccess" style="width: fit-content; padding: 1rem; border-radius: .3125rem;" (click)="redirectToTalentPool()">
                View Talentpool
              </button>
              <button data-testid="auto-app-person-search-listing-button-8"  (click)="closeAllModals()" class="ml-2 enabled-button" style="width: fit-content; padding: 1rem; border-radius: .3125rem;">
                <span *ngIf="addTalentPoolSuccess">Continue Search</span>
                <span *ngIf="!addTalentPoolSuccess">Close</span>
              </button>
            </div>
        </div>
      </ng-container>
    </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
    <span class="successCheck"><i class="fal fa-check"></i> </span>
    <span class="successmsg">{{ successMessage }}</span>
  </ngb-alert>

  <ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
    <span class="errorCheck"><i class="fal fa-times"></i></span>
    <span class="errormsg"> {{ errorMessage }} </span>
  </ngb-alert>

  <div class="row justify-content-start">
    <div id="overlay" (click)="closeNav()">
    </div>
  </div>

  <div id="quickView">
    <div class="" *ngIf="showCandidate">
      <app-person-search-candidate-slider [data]="currentCandidate" [viewMoreSkills]="viewMoreSkills" [highlightkeywords]="highlightkeywords" [tabType]="tabType" (childEvents)="eventHandler($event)" (handleOutputEvent) = "eventHandler($event)" [currentIndex]="currentIndex" (revealStatusEventEmitter)="getRevealContactStatus($event)" [calledfrompage]="'personsearchlistingpage'" (candidateExistInAegis)="aegisCandidateData($event)" [isAegisConnected]="isAegisConnected">
        <div addToTalentPool class="d-inline-flex">
          <div class="d-flex">


            <p class="add-to-talentpool text-webbtree-green pointer mr-2 text-nowrap" (click)="extractCandidate(currentCandidate)">
                <i class="fas fa-user-plus mr-1"></i>
                Add to Talent pool
            </p>
          </div>

            <span class="dropdown ats-dropBtn mx-1 mt-1 slider-drop">
                <span class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-ellipsis-v f-16 gray-text"></i>
                </span>
                <div class="dropdown-menu" aria-labelledby="userDropdownButton">
                  <a data-testid="auto-app-person-search-listing-a-4" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="exportToPDF()"> <i
                      class="fa-solid fa-download mr-2"></i>Export to PDF</a>
                      <!-- commented because of bugs -->
                      <!-- <a data-testid="auto-app-person-search-listing-a-5" class="dropdown-item f-12 isActive mr-2" (click)="openAddToEmailCampaign(currentCandidate)" title="Add to Email Campaign">
                        <i class="fa-solid fa-envelopes-bulk nr-2"></i> Add to email Campaign
                    </a> -->

                    <a data-testid="auto-app-person-search-listing-a-6" class="dropdown-item f-12 isActive mr-2" (click)="addToAegis(currentCandidate)" title="Add to Aegis"
                      *ngIf="isAddToAegisAvailable && isAegisConnected">
                      <img src="../../assets/search/aegis.png" alt="A"> Add to Aegis
                    </a>

                </div>
            </span>
        </div>

      </app-person-search-candidate-slider>
    </div>
  </div>


  <ng-template #getCompanyInformation>
    <img [src]="currentCompanyInformation.companylogo" alt="company name">
    <a data-testid="auto-app-person-search-listing-a-7" target="_blank" rel="noopener noreferrer" *ngIf="currentCompanyInformation.linkedin_url" (click)="openUrl(currentCompanyInformation.linkedin_url, 'linkedin')" class="mr-2">
       <i class="fa fa-linkedin-square f-16"  aria-hidden="true" style="color: #0652ba;"></i>
      </a>

      <i class="fas fa-globe" (click)="openUrl(currentCompanyInformation?.website, 'website')"></i>
    <p>{{currentCompanyInformation?.name}}</p>
    <p>{{currentCompanyInformation?.industry}}</p>
    <p>{{currentCompanyInformation?.location}}</p>
    <p>{{currentCompanyInformation?.size}}</p>
    <p>{{currentCompanyInformation?.tags?.join(', ')}}</p>
</ng-template>

<ng-template #addCandidateToEmailCampaign>
    <div class="modal-header b pb-0">
      <h5 class="f-14 font-weight-600" id="experience">Add Candidate to Email Campaign</h5>
      <button data-testid="auto-app-person-search-listing-button-9" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="closeActiveModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pb-3 pt-0">
      <div class="row mb-2 mt-2">
        <div class="col">
          <input data-testid="auto-app-person-search-listing-input-3"
            type="text"
            name="campaign_name"
            class="wc-form-control no-shadow w-100 inputheight mb-2"
            placeholder="Enter Campaign Name...."
            [formControl]="campaign_input"
            [matAutocomplete]="campaign_name"
            (input)="onTypeAheadSearchCampaign($event)"
            (click)="onTypeAheadSearchCampaign($event)"
          />
          <p *ngIf="campaign_input.errors?.required && (campaign_input.dirty || campaign_input.touched)"
          class="f-12 text-danger">Campaign Name is required</p>

          <mat-autocomplete #campaign_name="matAutocomplete" (optionSelected)="onCampaignSelected($event.option.value)">
            <mat-option *ngFor="let campaign of campaignList" [value]="campaign" [disabled]="campaign.remaining_targets <= 0">
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ campaign.campaign_name }}</span> <span class="badge badge-light border f-12 font-weight-normal text-9696" *ngIf="campaign.remaining_targets <= 0">Campaign limits reached</span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="row mb-0">
        <div class="col  d-flex justify-content-end">
          <button data-testid="auto-app-person-search-listing-button-10" class="btn-trms-small" (click)="!isLoadingEmailCampaignApi && addToEmailCampaign()" [disabled]="!campaign_input.valid">
            <span *ngIf="!isLoadingEmailCampaignApi">
                Add
            </span>
            <span *ngIf="isLoadingEmailCampaignApi">
                <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
              </span>
          </button>
        </div>
      </div>
    </div>
</ng-template>

<ng-template #addCandidateToScreenAiModal>
  <div class="modal-content">
    <div class="modal-header b pb-0">
      <h5 class="f-14 font-weight-600" id="downloadCSVModalHeading">Add to Screen AI</h5>
      <button data-testid="auto-app-person-search-listing-button-11" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="closeActiveModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pb-3 pt-0">
      <div *ngIf="!screenAiDuplicateCheckDone">
        <div class="row mb-2 mt-2">
          <div class="col">
            <input data-testid="auto-app-person-search-listing-input-4"
              type="text"
              class="wc-form-control no-shadow w-100 inputheight mb-2"
              placeholder="Enter Job Name...."
              [formControl]="job_input"
              [matAutocomplete]="job_name"
              (click)="getAllScreenAIJobs()"
            />
            <p *ngIf="job_input.errors?.required && (job_input.dirty || job_input.touched)"
                    class="f-12 text-danger">Job Name is required</p>
            <mat-autocomplete #job_name="matAutocomplete" (optionSelected)="onScreenAiJobSelected($event.option.value)">
              <mat-option *ngFor="let job of jobList" [value]="job" [disabled]="isScreeningInProgress(job)" [matTooltip]="getTooltipText(job)" [matTooltipClass]="{ 'eu-tooltip text-black': true }" matTooltipPosition="above">
                {{ job.name }} <span class="float-right text-right ml-auto f-12 mt-2 text-9696" *ngIf="job.batch_status === 'pending'">Screening in progress</span>
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
        <div class="row mb-0">
          <div class="col  d-flex justify-content-end">
            <button data-testid="auto-app-person-search-listing-button-12" class="btn-trms-small" (click)="!isLoadingScreenAiApi && addToScreenAi()" [disabled]="!job_input.valid">
              <span *ngIf="!isLoadingScreenAiApi">
                Add
              </span>
              <span *ngIf="isLoadingScreenAiApi">
                <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
              </span>
            </button>
          </div>
        </div>
        </div>
      <ng-container *ngIf="screenAiDuplicateCheckDone">
        <div class="px-3">
        <p>{{postAddMssg}}</p>
        <div class="float-right d-flex flex-row justify-content-end mb-2">
          <button data-testid="auto-app-person-search-listing-button-13" class="outlined-button" *ngIf="addCandidateSuccess" style="width: fit-content; padding: 1rem; border-radius: .3125rem;" (click)="redirectToScreenAi()">
            View Screen AI
          </button>
          <button data-testid="auto-app-person-search-listing-button-14"  (click)="closeActiveModal()" class="ml-2 enabled-button" style="width: fit-content; padding: 1rem; border-radius: .3125rem;">
            <span *ngIf="addCandidateSuccess" (click)="ngOnInit()">Continue Search</span>
            <span *ngIf="!addCandidateSuccess">Close</span>
          </button>
        </div>
    </div>
      </ng-container>
    </div>
    </div>
</ng-template>

<ng-template #addCandidateToIntegrationTemplate>
  <div class="modal-header b pb-0">
    <h5 class="f-14 font-weight-600" id="experience">
      <ng-container *ngIf="!selectedIntegration.duplicate">
        Adding Candidate to {{ selectedIntegration.name | titlecase }}
      </ng-container>
      <ng-container *ngIf="selectedIntegration.duplicate">
        Duplicate Candidates Found
      </ng-container>
    </h5>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="selectedIntegration.duplicate">
      <p>
        There were <strong>{{ selectedIntegration.count }}</strong> duplicate candidates found in {{ selectedIntegration.name | titlecase }} with the same name. Would you like to proceed anyway?
      </p>
      <div class="d-flex justify-content-end">
        <!-- cancel button -->
        <button data-testid="auto-app-person-search-listing-button-15" class="btn-trms-light border-0 mr-2" (click)="dismissAddCandidateToIntegrationModal()">
          Cancel
        </button>
        <!-- button to "proceed anyway" -->
        <button data-testid="auto-app-person-search-listing-button-16" class="btn-trms-small border-0" [ngClass]="{ 'disable-btn': selectedIntegration.processing }" (click)="addCandidateToIntegration(selectedIntegration, selectedIntegration.candidate, { 'force': true })" [disabled]="selectedIntegration.processing">
          <!-- loading icon when processing -->
          <span *ngIf="selectedIntegration.processing" class="mr-2">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </span>
          Proceed Anyway
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="!selectedIntegration.duplicate">
      <div class="d-flex align-items-center">
        <div class="spinner-border text-webbtree-green" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mb-0 ml-2">
          Please wait while we add the candidate...
        </p>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #tagToAtsJobTemplate>
  <div class="modal-header b pb-0">
    <h5 class="f-14 font-weight-600" id="experience">
      Tag Candidate to {{ selectedIntegration.name | titlecase }} Job
    </h5>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="selectedIntegration">
      <div class="row mb-2">
        <div class="col">
          <div class="alert alert-info p-2 position-initial" role="alert">
            <p class="mb-0">
              Tagging a candidate to an ATS job will help you keep track of the candidate's progress in the hiring process.
            </p>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <input data-testid="auto-app-person-search-listing-input-5" type="text" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Job Name...." [formControl]="unifiedJobInput" [matAutocomplete]="job_name" (click)="getAllScreenAIJobs()" />
          <p *ngIf="unifiedJobInput.errors?.required && (unifiedJobInput.dirty || unifiedJobInput.touched)" class="f-12 text-danger">
            Please select a job
          </p>
          <mat-autocomplete #job_name="matAutocomplete" (optionSelected)="onJobSelected($event)">
            <mat-option *ngFor="let job of unifiedJobList" [value]="job">
              {{ job.name }} <span class="float-right text-right ml-auto f-12 mt-2 text-9696" *ngIf="job.batch_status === 'pending'">Screening in progress</span>
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="row mb-0">
        <div class="col  d-flex justify-content-end">
          <button data-testid="auto-app-person-search-listing-button-17" class="btn-trms-light" (click)="closeAllModals()" [disabled]="isLoadingJobApi">
            Cancel
          </button>
          <button data-testid="auto-app-person-search-listing-button-18" class="btn-trms-small border-0 ml-2" (click)="!isLoadingJobApi && createUnifiedApplication()" [disabled]="!selectedIntegration.job" [ngClass]="{ 'disabled': isLoadingJobApi || !selectedIntegration.job }">
            <span *ngIf="!isLoadingJobApi">
                Tag
            </span>
            <span *ngIf="isLoadingJobApi">
                <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
              </span>
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!selectedIntegration">
      <div class="d-flex align-items-center">
        <p class="mb-0 ml-2">
          Something went wrong. Please try again later.
        </p>
      </div>
      <div class="d-flex justify-content-end">
        <button data-testid="auto-app-person-search-listing-button-19" class="btn-trms-light border-0" (click)="closeAllModals()">
          Close
        </button>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #addToEmailCampaignWithViewCampaign let-modal>
  <div class=" p-2 text-white" style="background-color: #53EBA4;">
    <p class="mb-0 d-flex align-items-center"><span><i class="fa-solid fa-check mx-2 text-white f-18"></i></span> <span>Profile added to Campaign</span><span class="text-truncate pointer font-weight-600" style="text-decoration: underline;" (click)="redirectToEmailCampaign(selectedCampaign?.campaign_id)">"{{campaignName}}".</span></p>
  </div>
</ng-template>
